// AUTO-GENERATED on dev/build startup. Gitignored — regenerated from .env.
export const RUNTIME_ENV = {
  MERCADO_PAGO_PUBLIC_KEY: "APP_USR-c3ae56b2-9aa0-4fac-871c-9d2a3a552267",
  API_BASE: "https://api.nosparasempre.com.br",
} as const;
